module.exports = __webpack_public_path__ + "static/media/folder.432cd58f.svg";